/** 404 page and the pay-host fallback page. */
export default {
  title: "This page has not been generated",
  subtitle: "Tell me more about this page, so I can generate it",
  payHost: {
    title: "AIStyle payments",
    body: "This page is for completing a payment. Open the link you were sent.",
  },
};
